import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => {
    return {
        selectStyle: {
            '&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                borderRadius: '4px',
                borderColor: theme.palette.grey.border,
                borderWidth: '1px',
            },
            '& .MuiInputBase-input': {
                width: 250,
                fontSize: '16px',
                [theme.breakpoints.down('md')]: {
                    width: 200,
                },
            },
            '&.Mui-focused > .MuiOutlinedInput-notchedOutline': {
                borderWidth: '2px',
                borderColor: theme.palette.primary.main,
            },
        },
    };
});

export default useStyles;
